import { useNavigate } from "react-router-dom";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { Button } from "@mui/material";
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
} from "recharts";
import RecentActivities from "../../features/dashboard/recentActivities";

const dauData = [
  { name: "Mon", users: 120 },
  { name: "Tue", users: 210 },
  { name: "Wed", users: 180 },
  { name: "Thu", users: 300 },
  { name: "Fri", users: 260 },
  { name: "Sat", users: 140 },
  { name: "Sun", users: 170 },
];

const Dashboard = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="main_title">
        <h1>Dashboard</h1>
      </div>

      <div className="stats_boxes gap_m">
        <a href="/manage-users" className="cards">
          <figure>
            <img src="/static/images/user_icon.svg" alt="Users" />
          </figure>
          <h2>50</h2>
          <p>Total Registered Users</p>
        </a>

        <a className="cards" href="/manage-users" >
          <figure>
            <img src="/static/images/user_icon.svg" alt="Active Users" />
          </figure>
          <h2>15</h2>
          <p>Active Users This Month</p>
        </a>

        <div className="cards" >
          <figure>
            <img src="/static/images/reward_icon.svg" alt="Revenue" />
          </figure>
          <h2>20</h2>
          <p>Loyalty Points Issued</p>
        </div>
        <div className="cards" >
          <figure>
            <img src="/static/images/reward_icon.svg" alt="Revenue" />
          </figure>
          <h2>20000</h2>
          <p>Loyalty Points Redeemed</p>
        </div>
      </div>

      <div className="grid_sc gap_m">
        {/* Daily Active Users Chart */}
        <div className="cards table_card">
          <div className="cards_header">
            <div className="left_s">
              <h2>Redemption Trends</h2>
            </div>
            <div className="right_s">
              <p>
                <span>A day</span>
                <span>A week</span>
                <span>A month</span>
                <span>A year</span>
              </p>
               <Button className="btn btn_black icon_btn"><FileDownloadIcon /> </Button>
            </div>
          </div>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={dauData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="users" fill="#38B6FF" />
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="cards table_card">
          <div className="cards_header">
            <div className="left_s">
              <h2>Top Performing Campaigns</h2>
            </div>
            <div className="right_s">
              <p>
                <span>A day</span>
                <span>A week</span>
                <span>A month</span>
                <span>A year</span>
              </p>
               <Button className="btn btn_black icon_btn"><FileDownloadIcon /> </Button>
            </div>
          </div>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={dauData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="users" fill="#38B6FF" />
            </BarChart>
          </ResponsiveContainer>
        </div>

      </div>
      <div className="cards cards table_card mt_20">
        <div className="main_title">
          <h2>Recent User Activities  <span> (Latest 10) </span> </h2>
        </div>
        <RecentActivities />
      </div>
    </>
  );
};

export default Dashboard;